import { IResourceComponentsProps } from "@refinedev/core";
import { MuiShowInferencer } from "@refinedev/inferencer/mui";

export const CategoryShow: React.FC<IResourceComponentsProps> = () => {
    return <MuiShowInferencer />;
};
